import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {JobInterface} from '../../shared/models/job.model';
import {ApplicationModel} from '../../shared/models/application.model';
import {Observable} from 'rxjs';

@Injectable({providedIn: 'root'})
export class JobsDataService {
    apiUrl = '/agri/'

    constructor(private http: HttpClient) {
    }


    getCurrentJob(jobId) {
        return this.http.get('agri/viewJob?jobId=' + jobId);
    }

    applyToJob(application: object, email) {
        return this.http.post('agri/applyToJob?email=' + email, application);
    }

    postCreatedJob(job: object) {
        // HTTP Request
        return this.http.post<JobInterface>('agri/createJob', job);
    }

    getMyApplications() {
        return this.http.get('/agri/viewMyApplications');
    }

    getApplication(appId): Observable<ApplicationModel> {
        return this.http.get<ApplicationModel>('/agri/viewJobApplication?applicationId=' + appId)
    }

    changeApplicationStatus(appId, newStatus) {
        return this.http.put('agri/changeApplicationStatus?applicationId=' + appId, newStatus);
    }

    getJobApplications(jobId, field, dir) {
        // return this.http.get('/agri/getJobApplications?jobId=' + jobId)
        return this.http.post('/agri/listJobApplicationsFiltered?jobId=' + jobId + '&page=0&size=100&sort=' + field + '&dir=' + dir, {})
    }

    applicationStatus(jobId: any) {
        return this.http.post('agri/hasAppliedToJob?jobId=' + jobId, {});
    }

    updateJobData(jobData: object, jobId: string) {
        return this.http.put('agri/updateJob?jobId=' + jobId, jobData)
    }

    getFavJobs() {
        return this.http.get('agri/getFavoriteListOfJobs');
    }

    getSimilarJob(jobId) {
        return this.http.get('agri/similarJobs?jobId=' + jobId);
    }

    getMyInterviews() {
        return this.http.get('agri/getMyApplicationsWithInterview')
    }

    addToFavorites(jobId: any) {
        return this.http.post('agri/addToFavoriteList?jobId=' + jobId, {});
    }

    deleteFavJob(jobId: any) {
        return this.http.delete('agri/deleteFromFavoriteList?jobId=' + jobId, {})
    }

    createEvent(eventData) {
        return this.http.post('agri/addEvent', eventData);
    }

    showRecentJobs() {
        return this.http.get('/agri/recentJobs');
    }

    listAllJobsFiltered(filterData: object) {
        return this.http.post('/agri/listAllJobsFiltered', filterData);
    }

    getFilteredJobs(size, page, sort, order, filterData: object) {
        return this.http.post('agri/listAllJobsFiltered?page=' + (page - 1) + '&size=' + size + '&sort=' + sort + '&dir=' + order, filterData)
    }

    addCommentToApplication(appId, message) {
        return this.http.put('agri/addCommentToApplication?applicationId=' + appId + '&message=' + message, {})
    }

    duplicateJob(jobId: any) {
        return this.http.post('agri/duplicateJob?jobId=' + jobId, {})
    }

}
